function timeAgo(date: Date) {
    const diff = (new Date().getTime() - new Date(date).getTime()) / 1000;

    const hours = diff / 3600;
    const minutes = (diff % 3600) / 60;
    const seconds = diff % 60;

    let timeAgoString = "";

    if (hours > 1) {
        timeAgoString += `${Math.round(hours)} orë`;
        timeAgoString += ` e ${Math.round(minutes)} min.`;
    } else if (minutes > 1) {
        timeAgoString += `${Math.round(minutes)} min.`;
    } else {
        timeAgoString += `${Math.round(seconds)} sek.`;
    }

    timeAgoString += " më parë";

    return timeAgoString;
}

function pad(n) {
    return n < 10 ? "0" + n : n;
}

export function formatDateTime(dateString: Date) {
    if (!dateString) {
        return "-";
    }

    const date = new Date(dateString);
    return `${pad(date.getDate())}-${pad(
        date.getMonth() + 1
    )}-${date.getFullYear()} ${pad(date.getHours())}:${pad(
        date.getMinutes()
    )}:${pad(date.getSeconds())}`;
}

export function formatDate(date: Date) {
    return formatDateTime(date);
}
